import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/product.actions';
import * as home from '../../../../actions/process.home.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import Table from './Table';
import FilterMenu from './FilterMenu';

import Snackbar from '../../../labels/Snackbar';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import { AddIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Products extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: '',
        filtro: {},
        window_searchs: this.props.window_searchs,
    };

    constructor(props) {
        super(props);
        props.allProducts();
        const tools = [toolbar(this.handleFilter)];
        this.props.setTools(tools);
        this.props.setSearch(true);
    }

    componentWillUnmount() {
        this.props.setTools([]);
        this.props.setSearch(false);
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (filtro) => {
        const { desechable, producible, estacion } = filtro;
        const tools = [toolbar(this.handleFilter, desechable || producible || estacion)];
        this.props.setTools(tools);
        this.setState({ open: undefined, filtro: filtro });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.displays_has_error) {
            this.setState({
                hide: false,
                open: undefined,
            });
            nextProps.props.allProducts();
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/xef/products/new_product');
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleError = (message) => {
        this.setState({ error: message });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    render() {
        const { info, products, products_is_loading, window_searchs, workstation } = this.props;
        const { error, filtro, open } = this.state;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '67')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    {products_is_loading && <Loading open opacity />}
                    <div className={'flex_80 center'}>
                        <div
                            className={'flex_full overflow_y_scroll height100 bg_ice_blue showbar'}
                        >
                            <Table
                                search={[...window_searchs]}
                                data={products}
                                filtro={filtro}
                                onError={this.handleError}
                            />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            filtro={filtro}
                            workstation={workstation}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Products.propTypes = {
    window_searchs: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        products: state.products,
        products_is_loading: state.products_is_loading,
        workstation: state.workstation,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Products));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/products/Index.js